import { useEffect, useState } from 'react';
import { getCachedDeviceInfo } from './deviceCheck';
import { Orientation } from '../types/RemoteDepositCheck.types';


function useScreenOrientation(onChange?: (orientation: Orientation)=> void): Orientation {
  const [orientation, setOrientation] = useState<Orientation>('portrait');
  const { platform, isFirefox } = getCachedDeviceInfo();

  useEffect(() => {
    // Do not track orientation for Android and all browsers except Firefox,
    // since fullscreen and orientation lock typically work well in most Android browsers.
    // However, Firefox does not support orientation locking reliably.
     if (platform === 'android' && !isFirefox) return ; 

    function hanldeOrientation(){
      const type = screen.orientation?.type || '';
       const newOrientation = type.includes('landscape') ? 'landscape' : 'portrait';
       setOrientation(newOrientation);
       onChange?.(newOrientation); // call optional callback. Used in RempoteDeposutCheckCapture component to reset iframe when screen orientation changes.
    };

    hanldeOrientation();
    screen.orientation.addEventListener('change', hanldeOrientation);

    return () => {
      screen.orientation.removeEventListener('change', hanldeOrientation);
    };
  }, [onChange]);

  return orientation;
}

export default useScreenOrientation;
